// Shared social links helper for building platform-aware URLs and display config
// Usage: const { platform, linkUrl } = getSocialPlatformConfig({ type, link });

export const getSocialPlatformConfig = (social) => {
  const platformConfig = {
    WhatsApp: {
      icon: "chat",
      color: "#25D366",
      displayName: "WhatsApp",
      urlPrefix: "https://wa.me/",
      urlPattern: (link) => link.replace(/[^0-9]/g, ""),
    },
    Telegram: {
      icon: "send",
      color: "#0088cc",
      displayName: "Telegram",
      urlPrefix: "https://t.me/",
    },
    Instagram: {
      icon: "photo_camera",
      color: "#E4405F",
      displayName: "Instagram",
      urlPrefix: "https://www.instagram.com/",
    },
    Facebook: {
      icon: "facebook",
      color: "#1877F2",
      displayName: "Facebook",
      urlPrefix: "https://www.facebook.com/",
    },
    Twitter: {
      icon: "flutter_dash",
      color: "#000000",
      displayName: "Twitter",
      urlPrefix: "https://twitter.com/",
    },
    LinkedIn: {
      icon: "business_center",
      color: "#0A66C2",
      displayName: "LinkedIn",
      urlPrefix: "https://www.linkedin.com/in/",
    },
    YouTube: {
      icon: "play_circle",
      color: "#FF0000",
      displayName: "YouTube",
      urlPrefix: "https://www.youtube.com/",
    },
    TikTok: {
      icon: "music_note",
      color: "#000000",
      displayName: "TikTok",
      urlPrefix: "https://www.tiktok.com/@",
    },
    Snapchat: {
      icon: "camera_alt",
      color: "#FFFC00",
      displayName: "Snapchat",
      textColor: "#000",
      urlPrefix: "https://www.snapchat.com/add/",
    },
    Discord: {
      icon: "chat_bubble",
      color: "#5865F2",
      displayName: "Discord",
      urlPrefix: "https://discord.com/users/",
    },
    Twitch: {
      icon: "sports_esports",
      color: "#9146FF",
      displayName: "Twitch",
      urlPrefix: "https://www.twitch.tv/",
    },
    GitHub: {
      icon: "code",
      color: "#181717",
      displayName: "GitHub",
      urlPrefix: "https://github.com/",
    },
    Reddit: {
      icon: "forum",
      color: "#FF4500",
      displayName: "Reddit",
      urlPrefix: "https://www.reddit.com/user/",
    },
    Pinterest: {
      icon: "push_pin",
      color: "#E60023",
      displayName: "Pinterest",
      urlPrefix: "https://www.pinterest.com/",
    },
    Medium: {
      icon: "article",
      color: "#000000",
      displayName: "Medium",
      urlPrefix: "https://medium.com/@",
    },
    Spotify: {
      icon: "mic",
      color: "#1DB954",
      displayName: "Spotify",
      urlPrefix: "https://open.spotify.com/",
    },
    Flickr: {
      icon: "photo",
      color: "#0063DC",
      displayName: "Flickr",
      urlPrefix: "https://www.flickr.com/people/",
    },
    StackOverflow: {
      icon: "code",
      color: "#F58025",
      displayName: "Stack Overflow",
      urlPrefix: "https://stackoverflow.com/users/",
    },
    Quora: {
      icon: "chat_bubble",
      color: "#B92B27",
      displayName: "Quora",
      urlPrefix: "https://www.quora.com/profile/",
    },
    Mastodon: {
      icon: "language",
      color: "#6364FF",
      displayName: "Mastodon",
      urlPrefix: "https://",
    },
    Threads: {
      icon: "chat_bubble",
      color: "#000000",
      displayName: "Threads",
      urlPrefix: "https://www.threads.net/@",
    },
    Vimeo: {
      icon: "play_circle",
      color: "#1AB7EA",
      displayName: "Vimeo",
      urlPrefix: "https://vimeo.com/",
    },
    Slack: {
      icon: "chat_bubble",
      color: "#4A154B",
      displayName: "Slack",
      urlPrefix: "https://",
    },
    Unsplash: {
      icon: "photo",
      color: "#000000",
      displayName: "Unsplash",
      urlPrefix: "https://unsplash.com/@",
    },
    Codepen: {
      icon: "code",
      color: "#000000",
      displayName: "Codepen",
      urlPrefix: "https://codepen.io/",
    },
    GitLab: {
      icon: "code",
      color: "#FC6D26",
      displayName: "GitLab",
      urlPrefix: "https://gitlab.com/",
    },
    Figma: {
      icon: "view_quilt",
      color: "#F24E1E",
      displayName: "Figma",
      urlPrefix: "https://www.figma.com/@",
    },
    Arattai: {
      icon: "forum",
      color: "#FF6B35",
      displayName: "Arattai",
      urlPrefix: "https://arattai.com/",
    },
    Other: {
      icon: "language",
      color: "#666666",
      displayName: "Other",
    },
  };

  const platform = platformConfig[social?.type] || platformConfig.Other;

  let linkUrl = social?.link || "";
  if (linkUrl.startsWith("http://") || linkUrl.startsWith("https://")) {
    // keep as-is
  } else if (platform.urlPrefix) {
    const cleanedLink = (linkUrl || "")
      .replace(/^https?:\/\//i, "")
      .replace(/^(www\.)?instagram\.com\//i, "")
      .replace(/^(www\.)?facebook\.com\//i, "")
      .replace(/^(www\.)?twitter\.com\//i, "")
      .replace(/^(www\.)?linkedin\.com\/(in\/)?/i, "")
      .replace(/^(www\.)?youtube\.com\//i, "")
      .replace(/^(www\.)?reddit\.com\/(user\/)?/i, "")
      .replace(/^(www\.)?pinterest\.com\//i, "")
      .replace(/^(www\.)?snapchat\.com\/(add\/)?/i, "")
      .replace(/^(www\.)?tiktok\.com\/@?/i, "")
      .replace(/^(www\.)?twitch\.tv\//i, "")
      .replace(/^(www\.)?github\.com\//i, "")
      .replace(/^(www\.)?medium\.com\/@?/i, "")
      .replace(/^(open\.)?spotify\.com\//i, "")
      .replace(/^(www\.)?flickr\.com\/(people\/)?/i, "")
      .replace(/^(www\.)?stackoverflow\.com\/(users\/)?/i, "")
      .replace(/^(www\.)?quora\.com\/(profile\/)?/i, "")
      .replace(/^(www\.)?threads\.net\/@?/i, "")
      .replace(/^(www\.)?vimeo\.com\//i, "")
      .replace(/^(www\.)?unsplash\.com\/@?/i, "")
      .replace(/^(www\.)?codepen\.io\//i, "")
      .replace(/^(www\.)?gitlab\.com\//i, "")
      .replace(/^discord\.com\/(users\/)?/i, "")
      .replace(/^t\.me\//i, "")
      .replace(/^wa\.me\//i, "")
      .replace(/^(www\.)?arattai\.com\//i, "")
      .replace(/^@/i, "");

    const processedLink = platform.urlPattern ? platform.urlPattern(cleanedLink) : cleanedLink;

    linkUrl = platform.urlPrefix + processedLink;
  } else {
    linkUrl = linkUrl ? (linkUrl.startsWith("http") ? linkUrl : `https://${linkUrl}`) : "";
  }

  return { platform, linkUrl };
};

// Optional: convenience method if you only need the URL
export const buildSocialLinkUrl = (social) => getSocialPlatformConfig(social).linkUrl;
